import {LocalStorageKey} from '@store/@types/util/LocalStorageKey';

export default class LocalStorageJson {
  static get(key: LocalStorageKey, fallback?: any) {
    const val = localStorage.getItem(key);

    if (val === null) {
      if (fallback !== undefined) {
        return fallback;
      }

      throw new Error(`No fallback specified for null value at key: ${key}`);
    }

    return JSON.parse(val);
  }

  static set(key: LocalStorageKey, value: any) {
    const str = JSON.stringify(value);
    localStorage.setItem(key, str);
  }
}
